<template>
  <div class="guideline-structure">
    <div class="page-header">
      <div class="header-content">
        <a-breadcrumb class="custom-breadcrumb">
          <a-breadcrumb-item
            ><router-link to="/mobile-cms/guidelines"
              >Sumber Guidelines</router-link
            ></a-breadcrumb-item
          >
          <a-breadcrumb-item
            ><router-link :to="`/mobile-cms/guidelines/${guideline?.source_id}`">{{
              guideline?.source?.name
            }}</router-link></a-breadcrumb-item
          >
          <a-breadcrumb-item>{{ guideline?.title }}</a-breadcrumb-item>
        </a-breadcrumb>
        <h1 class="guideline-title">{{ guideline?.title }}</h1>
      </div>
    </div>

    <div class="content-container">
      <div class="search-and-action">
        <a-row :gutter="16" style="width: 100%">
          <a-col :xs="24" :sm="16" :md="20">
            <a-input
              v-model:value="searchQuery"
              placeholder="Cari nama diagnosis"
              allow-clear
              size="large"
            >
              <template #prefix>
                <SearchOutlined style="color: rgba(0, 0, 0, 0.25); margin-right: 4px" />
              </template>
            </a-input>
          </a-col>
          <a-col :xs="24" :sm="8" :md="4">
            <button class="tambah-button" @click="showAddCategoryModal">
              <plus-outlined /> TAMBAH
            </button>
          </a-col>
        </a-row>
      </div>

      <div class="table-card">
        <div class="table-responsive custom-table-wrapper">
          <draggable
            v-model="categories"
            tag="table"
            class="custom-table"
            style="width: 100%"
            item-key="id"
            handle=".drag-handle"
            @change="updateOrder"
            :disabled="!!searchQuery"
          >
            <template #header>
              <thead>
                <tr>
                  <th style="width: 80px" class="text-center"></th>
                  <th>Kategori</th>
                  <th style="width: 250px">Aksi</th>
                </tr>
              </thead>
            </template>
            <template #item="{ element: category }">
              <tbody
                v-show="
                  !searchQuery ||
                    category.diagnoses.length > 0 ||
                    category.name.toLowerCase().includes(searchQuery.toLowerCase())
                "
              >
                <tr class="category-row">
                  <td style="width: 80px; text-align: center; padding: 16px 8px">
                    <div
                      style="display: flex; align-items: center; justify-content: center; gap: 16px"
                    >
                      <holder-outlined
                        class="drag-handle"
                        style="cursor: grab; color: #9ca3af; font-size: 16px"
                        v-if="!searchQuery"
                      />
                      <right-outlined
                        style="
                          font-size: 12px;
                          color: #6b7280;
                          cursor: pointer;
                          transition: transform 0.2s ease;
                        "
                        :style="{
                          transform: expandedRowKeys.includes(category.id)
                            ? 'rotate(90deg)'
                            : 'rotate(0deg)',
                        }"
                        @click="toggleExpand(category.id)"
                      />
                    </div>
                  </td>
                  <td
                    class="category-title-cell"
                    style="font-weight: 600; color: #111827; font-size: 16px; cursor: pointer"
                    @click="toggleExpand(category.id)"
                  >
                    {{ category.name }}
                  </td>
                  <td class="actions-cell" style="width: 250px">
                    <div class="category-actions" @click.stop>
                      <button
                        class="btn-action-pill edit-btn"
                        @click="showEditCategoryModal(category)"
                      >
                        <edit-outlined /> UBAH
                      </button>
                      <button
                        class="btn-action-pill delete-btn"
                        @click="confirmDeleteCategory(category)"
                      >
                        <delete-outlined /> HAPUS
                      </button>
                    </div>
                  </td>
                </tr>
                <tr v-if="expandedRowKeys.includes(category.id)" class="expanded-row">
                  <td colspan="3" style="padding: 0; background: transparent; border-bottom: none">
                    <div class="diagnosis-table-container">
                      <a-table
                        :columns="diagnosisColumns"
                        :data-source="category.diagnoses"
                        :pagination="false"
                        row-key="id"
                        class="inner-table"
                        :custom-row="customRow"
                      >
                        <template #status="{ record }">
                          <div class="status-cell">
                            <a-switch
                              :checked="record.is_active"
                              @change="val => toggleDiagnosisStatus(record, val)"
                              class="custom-switch"
                              :class="{ 'switch-active': record.is_active }"
                            />
                            <a-tag class="type-tag status-tag">
                              {{ record.is_active ? 'Aktif' : 'Nonaktif' }}
                            </a-tag>
                          </div>
                        </template>
                        <template #name="{ record }">
                          <a @click="goToDiagnosis(record)" class="diagnosis-link">{{
                            record.short_name
                          }}</a>
                        </template>
                        <template #action="{ record }">
                          <div class="action-buttons">
                            <button
                              class="btn-action-pill edit-btn"
                              @click="showEditDiagnosisModal(category, record)"
                            >
                              <edit-outlined /> UBAH
                            </button>
                            <button
                              class="btn-action-pill delete-btn"
                              @click="confirmDeleteDiagnosis(record)"
                            >
                              <delete-outlined /> HAPUS
                            </button>
                          </div>
                        </template>
                        <template #footer>
                          <button class="btn-add-inline" @click="showAddDiagnosisModal(category)">
                            <plus-outlined /> TAMBAH
                          </button>
                        </template>
                      </a-table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </template>
          </draggable>
        </div>
      </div>

      <!-- Category Modal -->
      <a-modal
        :title="categoryModalTitle"
        v-model:visible="categoryModalVisible"
        :confirm-loading="modalLoading"
        @cancel="handleCategoryModalCancel"
        :width="500"
        class="premium-modal"
        :footer="null"
      >
        <a-form :model="categoryForm" layout="vertical" ref="categoryFormRef" class="custom-form">
          <a-form-item
            name="name"
            :rules="[{ required: true, message: 'Nama kategori wajib diisi' }]"
          >
            <template #label>
              <span>Nama Kategori <span style="color: #ff4d4f">*</span></span>
            </template>
            <a-input
              v-model:value="categoryForm.name"
              placeholder="Masukkan nama kategori"
              size="large"
            />
          </a-form-item>

          <a-form-item class="mb-0 mt-8">
            <div class="d-flex justify-center modal-action-buttons">
              <button
                type="button"
                class="confirm-button"
                :disabled="modalLoading"
                @click="handleCategoryModalOk"
              >
                <span v-if="modalLoading" class="button-spinner"></span>
                {{ modalLoading ? 'MENYIMPAN...' : 'SIMPAN' }}
              </button>
              <button type="button" class="cancel-button" @click="handleCategoryModalCancel">
                KEMBALI
              </button>
            </div>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- Diagnosis Modal -->
      <a-modal
        :title="diagnosisModalTitle"
        v-model:visible="diagnosisModalVisible"
        :confirm-loading="modalLoading"
        @cancel="handleDiagnosisModalCancel"
        :width="650"
        class="premium-modal"
        :footer="null"
      >
        <a-form :model="diagnosisForm" layout="vertical" ref="diagnosisFormRef" class="custom-form">
          <a-form-item
            name="short_name"
            :rules="[{ required: true, message: 'Nama singkat wajib diisi' }]"
          >
            <template #label>
              <span>Nama Singkat Diagnosis <span style="color: #ff4d4f">*</span></span>
            </template>
            <div class="label-description">
              Nama yang akan ditampilkan pada list depan di aplikasi mobile
            </div>
            <a-input
              v-model:value="diagnosisForm.short_name"
              placeholder="Masukkan nama diagnosis"
              size="large"
            />
          </a-form-item>

          <a-form-item
            name="full_name"
            :rules="[{ required: true, message: 'Nama lengkap wajib diisi' }]"
          >
            <template #label>
              <span>Nama Lengkap Diagnosis <span style="color: #ff4d4f">*</span></span>
            </template>
            <div class="label-description">
              Nama yang akan ditampilkan pada halaman detail di aplikasi mobile
            </div>
            <a-input
              v-model:value="diagnosisForm.full_name"
              placeholder="Masukkan nama lengkap"
              size="large"
            />
          </a-form-item>

          <a-form-item name="is_active">
            <div></div>
            <template #label>
              <span>Status</span>
            </template>
            <div style="display: flex; align-items: center; gap: 8px">
              <a-switch
                v-model:checked="diagnosisForm.is_active"
                class="custom-switch"
                :class="{ 'switch-active': diagnosisForm.is_active }"
              />
              <a-tag class="type-tag status-tag">
                {{ diagnosisForm.is_active ? 'Aktif' : 'Nonaktif' }}
              </a-tag>
            </div>
          </a-form-item>

          <div>
            <div class="icd-dynamic-section">
              <span class="kode-icd">Kode ICD-10</span>
            </div>
            <div
              v-for="(code, index) in diagnosisForm.icd_codes"
              :key="index"
              class="icd-input-row mb-3 d-flex gap-x-2 align-center"
            >
              <a-input
                v-model:value="diagnosisForm.icd_codes[index]"
                placeholder="Masukkan kode diagnosis"
                size="large"
                style="flex: 1"
              />
              <button
                v-if="diagnosisForm.icd_codes.length > 1"
                type="button"
                class="btn-icon-delete"
                @click="removeIcdCode(index)"
              >
                <delete-outlined />
              </button>
            </div>
            <button type="button" class="btn-add-text" @click="addIcdCode">
              <plus-outlined /> TAMBAH KODE
            </button>
          </div>

          <a-form-item name="file" class="mt-4">
            <template #label>
              <span class="custom-form-label">File Clinical Pathway</span>
            </template>
            <a-upload
              :before-upload="onBeforeDiagnosisFileUpload"
              :show-upload-list="true"
              :max-count="1"
              accept=".pdf"
            >
              <button type="button" class="btn-upload-outline"><upload-outlined /> UNGGAH</button>
            </a-upload>
            <div v-if="diagnosisForm.currentFileUrl" class="mt-2">
              <p
                class="link-clinical-pathway"
                @click.prevent="openClinicalPathwayFile(diagnosisForm.currentFileUrl)"
              >
                {{ diagnosisForm.currentFileUrl.split('/').slice(-1)[0] }}
              </p>
            </div>
          </a-form-item>

          <a-form-item class="mb-0 mt-8">
            <div class="d-flex justify-center modal-action-buttons">
              <button
                type="button"
                class="confirm-button"
                :disabled="modalLoading"
                @click="handleDiagnosisModalOk"
              >
                <span v-if="modalLoading" class="button-spinner"></span>
                {{ modalLoading ? 'MENYIMPAN...' : 'SIMPAN' }}
              </button>
              <button type="button" class="cancel-button" @click="handleDiagnosisModalCancel">
                KEMBALI
              </button>
            </div>
          </a-form-item>
        </a-form>
      </a-modal>

      <!-- Dynamic Confirmation Modal -->
      <a-modal
        v-model:visible="confirmModalVisible"
        :title="confirmModalTitle"
        :footer="null"
        :closable="true"
        @cancel="confirmModalVisible = false"
        :width="450"
        class="premium-confirmation-modal"
        :z-index="9999"
      >
        <div class="confirm-content text-center">
          <p class="confirm-description">{{ confirmModalDescription }}</p>
          <div class="confirm-footer d-flex confirm-modal-action-buttons mt-8">
            <button class="btn-footer btn-confirm-cancel" @click="confirmModalVisible = false">
              KEMBALI
            </button>
            <button
              class="btn-footer btn-confirm-ok"
              :class="{ 'btn-danger': confirmModalType.includes('delete') }"
              @click="handleConfirmOk"
            >
              {{ confirmModalOkText }}
            </button>
          </div>
        </div>
      </a-modal>
    </div>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import { ref, reactive, computed, onMounted, watch, h } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { notification, message } from 'ant-design-vue'
import { RightOutlined } from '@ant-design/icons-vue'
import {
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
  SearchOutlined,
  HolderOutlined,
  UploadOutlined,
} from '@ant-design/icons-vue'
import { mobileCmsGuidelineAPI } from '@/services/axios/perki/mobileCms'
import { min } from 'lodash'

export default {
  name: 'MobileCmsGuidelineStructure',
  components: {
    draggable,
    HolderOutlined,
    RightOutlined,
    EditOutlined,
    DeleteOutlined,
    PlusOutlined,
    SearchOutlined,
    UploadOutlined,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const guidelineId = route.params.id

    const guideline = ref(null)
    const categories = ref([])
    const expandedRowKeys = ref([]) // Renamed from activeCategories for a-table
    const searchQuery = ref('')
    const modalLoading = ref(false)

    // Category State
    const categoryModalVisible = ref(false)
    const editingCategory = ref(null)
    const categoryFormRef = ref(null)
    const categoryForm = reactive({
      name: '',
      sort_order: 1,
    })

    // Diagnosis State
    const diagnosisModalVisible = ref(false)
    const editingDiagnosis = ref(null)
    const activeCategoryForDiagnosis = ref(null)
    const diagnosisFormRef = ref(null)
    const diagnosisForm = reactive({
      icd_codes: [''],
      file: null,
      currentFileUrl: '',
    })

    const getClinicalPathwayUrl = diagnosis => {
      if (!diagnosis || typeof diagnosis !== 'object') return ''

      const candidates = [
        diagnosis.clinical_pathway_file,
        diagnosis.clinical_pathway_file_url,
        diagnosis.clinical_pathway_url,
        diagnosis.clinical_pathway?.file,
        diagnosis.clinical_pathway?.url,
        diagnosis.clinical_pathway?.path,
        diagnosis.file_url,
        typeof diagnosis.file === 'string' ? diagnosis.file : null,
        diagnosis.file?.url,
        diagnosis.file?.path,
      ]

      const validUrl = candidates.find(value => typeof value === 'string' && value.trim())
      return validUrl ? validUrl.trim() : ''
    }

    const resolveUploadedFileUrl = fileUrl => {
      const rawUrl = (fileUrl || '').trim()
      if (!rawUrl) return ''
      if (/^https?:\/\//i.test(rawUrl)) return rawUrl

      const baseHost = (
        process.env.VUE_APP_PERKI_API_URL || 'http://localhost:3000/api/v1'
      ).replace(/\/api\/v1\/?$/, '')
      const normalizedPath = rawUrl.startsWith('/') ? rawUrl : `/${rawUrl}`
      return `${baseHost}${normalizedPath}`
    }

    const openClinicalPathwayFile = fileUrl => {
      const resolvedUrl = resolveUploadedFileUrl(fileUrl)
      if (!resolvedUrl) {
        notification.error({
          message: 'Error',
          description: 'File clinical pathway tidak tersedia.',
        })
        return
      }

      window.open(resolvedUrl, '_blank', 'noopener,noreferrer')
    }

    // Confirmation Modal State
    const confirmModalVisible = ref(false)
    const confirmModalType = ref('') // 'category-save', 'category-edit', 'category-delete', 'diagnosis-save', etc.
    const confirmModalTarget = ref(null)

    const categoryModalTitle = computed(() =>
      editingCategory.value ? 'Ubah Kategori' : 'Tambah Kategori',
    )
    const diagnosisModalTitle = computed(() =>
      editingDiagnosis.value ? 'Ubah Diagnosis' : 'Tambah Diagnosis',
    )

    const confirmModalTitle = computed(() => {
      if (confirmModalType.value.includes('delete')) return 'Hapus data?'
      if (confirmModalType.value.includes('edit')) return 'Ubah data?'
      return 'Yakin isi formulir sudah sesuai?'
    })

    const confirmModalDescription = computed(() => {
      if (confirmModalType.value.includes('delete'))
        return 'Data yang dihapus tidak dapat dikembalikan. Apakah Anda yakin ingin melanjutkan?'
      if (confirmModalType.value.includes('edit'))
        return 'Mohon cek kembali perubahan data sebelum menyimpan formulir.'
      return 'Mohon cek kembali data sebelum menyimpan formulir.'
    })

    const confirmModalOkText = computed(() => {
      if (confirmModalType.value.includes('delete')) return 'YA, HAPUS'
      return 'YA, SIMPAN'
    })

    const showSuccessNotification = msg => {
      notification.success({
        message: 'Success',
        description: msg,
        placement: 'topRight',
        // icon: () => h(CheckCircleOutlined, { style: 'color: #10b981' }),
        class: 'premium-notification',
        duration: 3,
      })
    }

    const categoryColumns = [
      {
        title: 'Kategori',
        key: 'categoryName',
        dataIndex: 'name',
        width: '80%',
        customHeaderCell: () => ({ style: { minWidth: '250px' } }),
        customCell: () => ({ style: { minWidth: '250px' } }),
        sorter: (a, b) => a.name.localeCompare(b.name),
      },
      {
        title: 'Aksi',
        key: 'categoryActions',
        width: '250px',
        slots: { customRender: 'categoryActions' },
      },
    ]

    const diagnosisColumns = [
      {
        title: 'Diagnosis',
        key: 'name',
        slots: { customRender: 'name' },
        width: '60%',
        customHeaderCell: () => ({ style: { minWidth: '250px' } }),
        customCell: () => ({ style: { minWidth: '250px' } }),
        sorter: (a, b) => (a.short_name || '').localeCompare(b.short_name || ''),
      },
      { title: 'Status', key: 'status', slots: { customRender: 'status' } },
      {
        title: '',
        key: 'action',
        slots: { customRender: 'action' },
        align: 'right',
        width: '234px',
      },
    ]

    const filteredCategories = computed(() => {
      if (!searchQuery.value) {
        return categories.value
      }
      const query = searchQuery.value.toLowerCase()
      return categories.value
        .map(category => {
          const filteredDiagnoses = category.diagnoses.filter(
            diagnosis =>
              diagnosis.full_name.toLowerCase().includes(query) ||
              diagnosis.short_name.toLowerCase().includes(query) ||
              (diagnosis.icd_codes &&
                diagnosis.icd_codes.some(icd => icd.code.toLowerCase().includes(query))),
          )
          return {
            ...category,
            diagnoses: filteredDiagnoses,
          }
        })
        .filter(
          category => category.diagnoses.length > 0 || category.name.toLowerCase().includes(query),
        )
    })

    watch(filteredCategories, newVal => {
      // Automatically expand categories that have matching diagnoses when searching
      if (searchQuery.value) {
        expandedRowKeys.value = newVal.map(cat => cat.id)
      } else {
        // Optionally collapse all when search is cleared, or keep previous state
        // For now, let's keep them expanded if they were before, or collapse if not explicitly expanded
        // This might need more sophisticated logic depending on desired UX
        // For simplicity, let's just clear if search is cleared
        expandedRowKeys.value = []
      }
    })

    const handleExpandedRowsChange = keys => {
      expandedRowKeys.value = keys
    }
    const customRow = record => {
      return {
        onClick: event => {
          // Prevent navigation when clicking on recursive interactive elements
          const target = event.target
          if (
            target.tagName !== 'BUTTON' &&
            target.tagName !== 'A' &&
            target.tagName !== 'INPUT' &&
            !target.closest('button') &&
            !target.closest('.ant-switch') &&
            !target.closest('.action-buttons')
          ) {
            goToDiagnosis(record)
          }
        },
      }
    }

    const toggleExpand = id => {
      const idx = expandedRowKeys.value.indexOf(id)
      if (idx > -1) {
        expandedRowKeys.value.splice(idx, 1)
      } else {
        expandedRowKeys.value.push(id)
      }
    }

    const updateOrder = async () => {
      categories.value.forEach((cat, index) => {
        cat.sort_order = index + 1
      })
      try {
        const categoriesData = categories.value.map(c => ({
          id: c.id,
          sort_order: c.sort_order,
        }))
        await mobileCmsGuidelineAPI.reorderCategories({ categories: categoriesData })
        notification.success({
          message: 'Success',
          description: 'Urutan kategori berhasil diperbarui.',
          placement: 'topRight',
          class: 'premium-notification',
          duration: 3,
        })
      } catch (error) {
        console.error('Failed to reorder:', error)
        message.error('Gagal memperbarui urutan kategori.')
        await loadCategories()
      }
    }

    const loadGuideline = async () => {
      const res = await mobileCmsGuidelineAPI.getById(guidelineId)
      guideline.value = res.data.data
    }

    const loadCategories = async () => {
      const res = await mobileCmsGuidelineAPI.getCategories(guidelineId)
      categories.value = res.data.data
      // Expand all categories by default on initial load
      expandedRowKeys.value = categories.value.map(cat => cat.id)
    }

    const toggleDiagnosisStatus = async (record, val) => {
      try {
        await mobileCmsGuidelineAPI.updateDiagnosis(record.id, { is_active: val })
        record.is_active = val
        showSuccessNotification('Status berhasil diperbarui.')
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal memperbarui status.' })
      }
    }

    const goToDiagnosis = record => {
      router.push(`/mobile-cms/guidelines/diagnosis/${record.id}`)
    }

    // Category CRUD
    const showAddCategoryModal = () => {
      editingCategory.value = null
      categoryForm.name = ''
      categoryForm.sort_order = categories.value.length + 1
      categoryModalVisible.value = true
      // categoryFormRef.value?.resetFields()
    }

    const showEditCategoryModal = category => {
      editingCategory.value = category
      categoryForm.name = category.name
      categoryForm.sort_order = category.sort_order
      categoryModalVisible.value = true
      // categoryFormRef.value?.resetFields()
    }
    const handleCategoryModalOk = async () => {
      try {
        await categoryFormRef.value.validate()
        confirmModalType.value = editingCategory.value ? 'category-edit' : 'category-save'
        confirmModalVisible.value = true
      } catch {
        return
      }
    }

    const handleConfirmOk = async () => {
      const type = confirmModalType.value
      confirmModalVisible.value = false

      if (type === 'category-delete') {
        await deleteCategory(confirmModalTarget.value)
        return
      }
      if (type === 'diagnosis-delete') {
        await deleteDiagnosis(confirmModalTarget.value)
        return
      }

      modalLoading.value = true
      try {
        if (type.startsWith('category-')) {
          const payload = {
            guideline_id: guidelineId,
            name: categoryForm.name,
            sort_order: categoryForm.sort_order,
          }
          if (editingCategory.value) {
            await mobileCmsGuidelineAPI.updateCategory(editingCategory.value.id, payload)
            showSuccessNotification('Kategori kasus berhasil diubah.')
          } else {
            await mobileCmsGuidelineAPI.createCategory(payload)
            showSuccessNotification('Kategori kasus berhasil ditambahkan.')
          }
          categoryModalVisible.value = false
          categoryFormRef.value?.resetFields()
          loadCategories()
        } else if (type.startsWith('diagnosis-')) {
          const formData = new FormData()
          formData.append('category_id', activeCategoryForDiagnosis.value.id)
          formData.append('short_name', diagnosisForm.short_name)
          formData.append('full_name', diagnosisForm.full_name)
          formData.append('is_active', diagnosisForm.is_active)

          const icdCodesString = diagnosisForm.icd_codes
            .filter(code => code.trim() !== '')
            .join(',')
          formData.append('icd_codes', icdCodesString)
          if (diagnosisForm.file) {
            formData.append('file', diagnosisForm.file)
          }

          if (editingDiagnosis.value) {
            await mobileCmsGuidelineAPI.updateDiagnosis(editingDiagnosis.value.id, formData)
            showSuccessNotification('Diagnosis berhasil diubah.')
          } else {
            await mobileCmsGuidelineAPI.createDiagnosis(formData)
            showSuccessNotification('Diagnosis berhasil ditambahkan.')
          }
          diagnosisModalVisible.value = false
          diagnosisFormRef.value?.resetFields()
          loadCategories()
        }
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal menyimpan data.' })
      } finally {
        modalLoading.value = false
      }
    }

    const handleCategoryModalCancel = () => {
      categoryModalVisible.value = false
      categoryFormRef.value?.resetFields()
    }

    const confirmDeleteCategory = category => {
      confirmModalTarget.value = category
      confirmModalType.value = 'category-delete'
      confirmModalVisible.value = true
    }

    const deleteCategory = async category => {
      try {
        await mobileCmsGuidelineAPI.deleteCategory(category.id)
        showSuccessNotification('Kategori kasus berhasil dihapus.')
        loadCategories()
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal menghapus kategori.' })
      }
    }

    // Diagnosis CRUD
    const showAddDiagnosisModal = category => {
      activeCategoryForDiagnosis.value = category
      editingDiagnosis.value = null
      diagnosisForm.short_name = ''
      diagnosisForm.full_name = ''
      diagnosisForm.is_active = true
      diagnosisForm.icd_codes = ['']
      diagnosisForm.file = null
      diagnosisForm.currentFileUrl = ''
      diagnosisModalVisible.value = true
      // diagnosisFormRef.value?.resetFields()
    }

    const addIcdCode = () => {
      diagnosisForm.icd_codes.push('')
    }

    const removeIcdCode = index => {
      diagnosisForm.icd_codes.splice(index, 1)
    }

    const onBeforeDiagnosisFileUpload = file => {
      diagnosisForm.file = file
      return false
    }

    const showEditDiagnosisModal = async (category, diagnosis) => {
      activeCategoryForDiagnosis.value = category
      diagnosisForm.short_name = diagnosis.short_name
      diagnosisForm.full_name = diagnosis.full_name
      diagnosisForm.is_active = diagnosis.is_active
      diagnosisForm.icd_codes =
        diagnosis.icd_codes && diagnosis.icd_codes.length > 0
          ? diagnosis.icd_codes.map(c => c.code)
          : ['']
      diagnosisForm.file = null
      diagnosisForm.currentFileUrl = getClinicalPathwayUrl(diagnosis)
      // Set data awal dari list dulu agar modal langsung terbuka
      editingDiagnosis.value = diagnosis
      diagnosisModalVisible.value = true

      // Fetch detail untuk mendapatkan clinical_pathway_file
      try {
        const res = await mobileCmsGuidelineAPI.getDiagnosisById(diagnosis.id)
        const detailDiagnosis = res.data?.data || {}
        editingDiagnosis.value = {
          ...diagnosis,
          ...detailDiagnosis,
        }
        diagnosisForm.currentFileUrl = getClinicalPathwayUrl(editingDiagnosis.value)
      } catch {
        // Jika gagal, tetap pakai data list yang sudah di-set
      }
      // diagnosisFormRef.value?.resetFields()
    }
    const handleDiagnosisModalOk = async () => {
      try {
        await diagnosisFormRef.value.validate()
        confirmModalType.value = editingDiagnosis.value ? 'diagnosis-edit' : 'diagnosis-save'
        confirmModalVisible.value = true
      } catch {
        return
      }
    }

    const handleDiagnosisModalCancel = () => {
      diagnosisModalVisible.value = false
      diagnosisForm.currentFileUrl = ''
      diagnosisFormRef.value?.resetFields()
    }

    const confirmDeleteDiagnosis = diagnosis => {
      confirmModalTarget.value = diagnosis
      confirmModalType.value = 'diagnosis-delete'
      confirmModalVisible.value = true
    }

    const deleteDiagnosis = async diagnosis => {
      try {
        await mobileCmsGuidelineAPI.deleteDiagnosis(diagnosis.id)
        showSuccessNotification('Diagnosis berhasil dihapus.')
        loadCategories()
      } catch (error) {
        notification.error({ message: 'Error', description: 'Gagal menghapus diagnosis.' })
      }
    }

    const customExpandIcon = ({ expanded, onExpand, record }) => {
      return h(RightOutlined, {
        style: {
          fontSize: '12px',
          color: '#6b7280',
          marginRight: '8px',
          transition: 'transform 0.2s ease',
          transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
          cursor: 'pointer',
        },
        onClick: e => onExpand(record, e),
      })
    }

    onMounted(() => {
      loadGuideline()
      loadCategories()
    })

    return {
      guideline,
      categories,
      expandedRowKeys, // Changed from activeCategories
      searchQuery,
      modalLoading,
      categoryModalVisible,
      categoryFormRef,
      categoryForm,
      categoryModalTitle,
      diagnosisModalVisible,
      diagnosisFormRef,
      diagnosisForm,
      diagnosisModalTitle,
      categoryColumns, // New
      diagnosisColumns,
      filteredCategories, // New
      handleExpandedRowsChange,
      toggleExpand,
      updateOrder,
      toggleDiagnosisStatus,
      goToDiagnosis,
      showAddCategoryModal,
      showEditCategoryModal,
      handleCategoryModalOk,
      handleConfirmOk,
      confirmDeleteCategory,
      handleCategoryModalCancel,
      deleteCategory,
      showAddDiagnosisModal,
      showEditDiagnosisModal,
      handleDiagnosisModalOk,
      confirmDeleteDiagnosis,
      handleDiagnosisModalCancel,
      deleteDiagnosis,
      onBeforeDiagnosisFileUpload,
      resolveUploadedFileUrl,
      openClinicalPathwayFile,
      addIcdCode,
      removeIcdCode,
      customRow,
      customExpandIcon,
      confirmModalVisible,
      confirmModalTitle,
      confirmModalDescription,
      confirmModalOkText,
      confirmModalType,
    }
  },
}
</script>

<style lang="scss">
/* Global overrides for teleported modal content */
.premium-modal .ant-modal-title {
  font-size: 20px;
  font-weight: 700 !important;
  color: #111827;
}

.premium-confirmation-modal .ant-modal-title {
  font-size: 20px;
  font-weight: 700 !important;
  color: #111827;
}

.ant-modal-header {
  border-bottom: none !important;
  text-align: left;
  padding: 24px 24px 0px 24px !important;
}

.ant-table-column-sorter-up.on,
.ant-table-column-sorter-down.on {
  color: #e10f28 !important;
}
</style>

<style lang="scss" scoped>
@import '../../styleViews.scss';

/* Modal form overrides */
.premium-modal {
  position: relative;
}

.premium-modal :deep(.ant-modal-close-x) {
  font-size: 18px;
}

.custom-form :deep(.ant-form-item) {
  margin-bottom: 24px;
}

.custom-form :deep(label.ant-form-item-required) {
  margin-bottom: 0 !important;
  font-weight: 600;
}

.custom-form :deep(.ant-form-item-label > label) {
  font-weight: 600;
  color: #374151;
}

.custom-form :deep(.ant-form-item-label > label::after),
.custom-form :deep(.ant-form-item-label > label.ant-form-item-required::before),
.custom-form :deep(.ant-form-item-label > label.ant-form-item-required::after) {
  display: none !important;
  content: none !important;
}

.premium-modal :deep(.ant-input),
.premium-modal :deep(.ant-input-number) {
  border-radius: 8px;
  border-color: #d1d5db;
  font-size: 14px;
}

:deep(.ant-input::placeholder) {
  color: #798892 !important;
  opacity: 1 !important;
}

.guideline-structure {
  background: #fcfcfc;
  min-height: 100vh;

  @media (max-width: 768px) {
    padding: 4px;
  }
}

.custom-breadcrumb {
  margin-bottom: 8px;
}

.content-container {
  border-radius: 8px;

  @media (max-width: 768px) {
    padding: 0;
  }
}

.guideline-title {
  font-size: 30px;
  font-weight: 700;
  color: #282828;
  padding: 24px 0px;

  @media (max-width: 768px) {
    font-size: 20px;
  }
}

.search-and-action {
  margin-bottom: 24px;

  :deep(.ant-input::placeholder) {
    color: #999999 !important;
    opacity: 1 !important;
    font-size: 14px;
  }
}

.tambah-button {
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #e10f28;
  width: 100%;
  background: #e10f28;
  color: white;
  padding: 6px 12px;
  transition: all 0.3s;
  font-family: 'Barlow', sans-serif !important;
  cursor: pointer;

  @media (max-width: 576px) {
    margin-top: 12px;
  }

  &:hover {
    background: white !important;
    border-color: #e10f28 !important;
    color: #e10f28 !important;
  }
}

.icd-dynamic-section {
  display: flex;
  margin-bottom: 12px;
}

.kode-icd {
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 700;
  color: #374151;
}

.type-tag {
  border-radius: 20px;
  padding: 4px 12px;
  font-weight: 400;
  border: 0.5px solid;
  font-size: 12px;
}

.status-tag {
  border-color: #d9d9d9;
  background: #fafafa;
  color: #183e6f;
}

/* Outer table styles */
.table-card {
  overflow: hidden;
}

.custom-table-wrapper {
  margin-top: 16px;
  border-radius: 8px;
  overflow-x: auto;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;

  thead {
    tr {
      th {
        background: #f2f4f8 !important;
        font-weight: 600;
        color: #262626;
        padding: 16px 24px;
        border-bottom: 1px solid #e5e7eb;
        text-align: left;
      }
    }
  }

  tbody {
    .category-row {
      border-bottom: 1px solid #f3f4f6;
      transition: background-color 0.2s;
      background: #ffffff;

      &:hover {
        background-color: #f5f5f5;
      }

      td {
        padding: 16px 24px;
        vertical-align: middle;
      }
    }
  }
}

.category-name {
  font-weight: 700;
  font-size: 16px;
  color: #111827;
}

.category-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}

.btn-action-pill {
  height: 32px;
  padding: 0 16px;
  border-radius: 16px;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  background: white;
  border: 1px solid #d1d5db;
}

.delete-btn {
  background: #1f2937;
  color: white;
  border: none;
}

.diagnosis-table-container {
  padding: 0 0;
  /* Adjust padding for the inner table container */
  background: #f9fafb;
  /* Background for the expanded area */
}

/* Inner table styles */
.inner-table {
  background: #f0f2f4;
  overflow: hidden;
  padding: 0px 8px;
  padding-left: 90px;
}

.inner-table :deep(.ant-table-thead > tr > th) {
  background: #f9fafb;
  font-weight: 600;
  padding: 12px 16px;
}

.inner-table :deep(.ant-table-tbody > tr > td) {
  padding: 12px 16px;
}

.inner-table :deep(.ant-table-placeholder) {
  background: #f0f2f4;
}

.custom-table :deep(.ant-table-row) {
  cursor: pointer;
}

.diagnosis-link {
  color: #111827;
  font-weight: 400;

  &:hover {
    color: #dc2626;
  }
}

.status-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

:deep(.custom-switch.ant-switch) {
  background-color: #d1d5db;
}

:deep(.custom-switch.switch-active.ant-switch) {
  background-color: #e10f28;
}

.btn-add-inline {
  margin-top: 12px;
  color: #dc2626;
  background: transparent;
  border: none;
  font-weight: 700;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  margin-left: 16px;
  /* Align with inner table content */

  &:hover {
    color: #b91c1c;
  }
}

.action-buttons {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
}

.label-description {
  font-size: 13px;
  color: #9ca3af;
  font-weight: 400;
  margin-top: 2px;
}

.icd-input-row {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-icon-delete {
  background: none;
  border: none;
  font-size: 18px;
  color: #374151;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #dc2626;
  }
}

.btn-add-text {
  background: none;
  border: none;
  color: #111827;
  font-weight: 700;
  font-size: 14px;
  font-family: 'Barlow', sans-serif !important;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0;
  cursor: pointer;
  margin: 8px 0;

  &:hover {
    color: #4b5563;
  }
}

.modal-footer {
  display: flex;
  justify-content: flex-start;
  gap: 12px;
  padding: 16px 24px 24px 24px;
}

.btn-footer {
  height: 48px;
  padding: 0 40px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.btn-save {
  background-color: #dc2626;
  border: 1px solid #dc2626;
  color: white;

  &:hover {
    background-color: #b91c1c;
    border-color: #b91c1c;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
}

.btn-cancel {
  background-color: white;
  border: 2px solid #111827;
  color: #111827;

  &:hover {
    background-color: #f3f4f6;
  }
}

.btn-upload-outline {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 20px;
  margin-top: 4px;
  border-radius: 18px;
  border: 1px solid $primary;
  background: white;
  color: $primary;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &:hover {
    background: $primary;
    color: $white;
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.modal-action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.cancel-button {
  max-width: 230px;
  background: #ffffff;
  border: 2px solid #1a1a1a;
  color: #1a1a1a;
  border-radius: 50px;
  padding: 6px 16px;
  font-size: 14px;
  font-weight: 700;
  font-family: 'Barlow' !important;
  cursor: pointer;
  transition: all 0.3s;
  height: 40px;

  &:hover {
    background: #1a1a1a;
    color: white;
  }
}

.confirm-button {
  border-radius: 50px;
  font-size: 14px;
  font-weight: 700;
  border: 2px solid #e10f28;
  max-width: 150px;
  background: #e10f28;
  color: white;
  padding: 6px 16px;
  transition: all 0.3s;
  height: 40px;
  line-height: 1.5;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-family: 'Barlow' !important;

  @media (max-width: 768px) {
    width: 100%;
  }

  &:hover:not(:disabled) {
    background: white;
    border-color: #e10f28;
    color: #e10f28;
  }

  &:disabled {
    border-color: #98a2b3;
    background: #98a2b3;
    color: white;
    cursor: not-allowed;
    opacity: 0.8;
  }

  .button-spinner {
    width: 14px;
    height: 14px;
    border: 2px solid #ffffff;
    border-top: 2px solid transparent;
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
}

.premium-confirmation-modal {
  z-index: 9999;
}

.premium-confirmation-modal :deep(.ant-modal-content) {
  border-radius: 16px;
  padding: 12px;
}

.premium-confirmation-modal :deep(.ant-modal-header) {
  border-bottom: none;
  text-align: left;
  padding: 24px 24px 0 24px;
}

.premium-confirmation-modal :deep(.ant-modal-title) {
  font-size: 24px;
  font-weight: 700;
  color: #111827;
}

.confirm-description {
  font-size: 16px;
  color: #4b5563;
  text-align: left;
  margin-bottom: 28px;
}

.confirm-modal-action-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.btn-confirm-cancel {
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;

  align-items: center;
  justify-content: center;
  background: white;
  border: 1px solid #111827;
  color: #111827;

  &:hover {
    background: #111827;
    border: 1px solid #111827;
    color: white;
  }
}

.btn-confirm-ok {
  padding: 8px 20px;
  border-radius: 24px;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;

  align-items: center;
  justify-content: center;
  background: #dc2626;
  color: white;
  border: 1px solid $primary;

  &:hover {
    background: transparent;
    color: $primary;
    border: 1px solid $primary;
  }
}

/* Notification Styling */
:deep(.premium-notification) {
  border-radius: 12px;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1);

  .ant-notification-notice-message {
    font-weight: 700;
    margin-bottom: 4px;
  }

  .ant-notification-notice-description {
    font-size: 14px;
    color: #4b5563;
  }

  .ant-notification-notice-close {
    top: 16px;
    right: 16px;
  }
}

.inner-table :deep(.ant-table-thead > tr > th) {
  background: #f0f2f4 !important;
  border-bottom: 1px solid #eeeeee !important;
}

.inner-table :deep(.ant-table-tbody > tr > td) {
  background: #f0f2f4 !important;
  border-bottom: 1px solid #eeeeee !important;
}

.custom-table :deep(.ant-table-expanded-row > td) {
  background: #f0f2f4 !important;
}

.inner-table :deep(.ant-table-footer) {
  background: #f0f2f4 !important;
}

.inner-table
  :deep(.ant-table-tbody
    > tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)
    > td) {
  background: #e4e9f0 !important; // hover state for inner table
}
.link-clinical-pathway {
  transition: all 0.2s ease-in-out;
  color: $primary;
  font-weight: 700;
  text-decoration: underline;
  &:hover {
    color: $black;
    cursor: pointer;
  }
}
</style>
